import {HttpServices} from "../Helpers";
import {PHP_V13_URL} from "../api/urls";

export const GetTableColumns = async ({feature_name}) => {
  const queryList = [];
  if (feature_name) queryList.push(`feature_name=${feature_name}`);

  const result = await HttpServices.get(
    `${PHP_V13_URL}/api/${
      process.env.REACT_APP_VERSION_API
    }/service/gridview/view?${queryList.join("&")}`
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const UpdateTableColumns = async ({feature_name, columns}) => {
  const result = await HttpServices.put(
    `${PHP_V13_URL}/api/${process.env.REACT_APP_VERSION_API}/service/gridview/update`,
    {
      feature_name,
      columns,
    }
  )
    .then((data) => data)
    .catch((error) => error.response);

  return result;
};

export const DynamicService = async ({
  method,
  path,
  data,
  params,
  body,
  headers,
}) => {
  let result;
  if (method === "post" || method === "put")
    result = await HttpServices[method](path, body, {
      data,
      params,
      headers,
    })
      .then((response) => response)
      .catch((error) => error.response);
  else
    result = await HttpServices[method](path, {
      data,
      params: params || body,
      headers,
    })
      .then((response) => response)
      .catch((error) => error.response);

  return result;
};
